import { render, staticRenderFns } from "./WfUserContainerModal.Style#Drawer.vue?vue&type=template&id=6b7e2a87&scoped=true&"
import script from "./WfUserContainerModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./WfUserContainerModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./WfUserContainerModal.Style#Drawer.vue?vue&type=style&index=0&id=6b7e2a87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e2a87",
  null
  
)

export default component.exports